class LazyVideo extends HTMLElement {
  #observer = null;

  connectedCallback() {
    const video = this.querySelector('video');
    const source = video?.querySelector('source[data-src]');
    const url = this.dataset.videoUrl || source?.dataset.src;

    if (!video || !url) return;

    const loadVideo = () => {
      if (source) {
        source.src = url;
      } else {
        video.src = url;
      }

      video.load();
      video.play().catch(() => {});
    };

    if (this.hasAttribute('data-eager')) {
      loadVideo();
      return;
    }

    if (!('IntersectionObserver' in window)) {
      loadVideo();
      return;
    }

    this.#observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          loadVideo();
          this.#observer?.disconnect();
        }
      },
      { rootMargin: '200px' }
    );

    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }
}

if (!customElements.get('lazy-video')) {
  customElements.define('lazy-video', LazyVideo);
}
